import { Input } from "components/shadcn/components/ui/input";
import { forwardRef } from "react";

export const BaseInput = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  function RefInput(props, ref) {
    return <Input {...props} ref={ref} />;
  }
);
